import HoaDonViewPage from "./HoaDonViewPage";

export default HoaDonViewPage